import globalConfig from './global.json';
import { DEFAULT_CULTURE } from './constants';
import { getCultureInfo } from './utils';

const culture = localStorage.getItem('culture') || DEFAULT_CULTURE; // Default to 'en-US' if not set

const cultureValues = getCultureInfo(culture);
Object.assign(globalConfig, cultureValues);

export const {
	CULTURE_INFO,
	CULTURE_LANG,
	CULTURE_CURRENCY,
	CULTURE_CURRENCY_ALTERNATIVE,
	CULTURE_DATE_FORMAT,
	VOLUME_DISCOUNT,
	PREFERRED_DISCOUNT,
	BAN_LVL_DISCOUNT,
	PRICE_LIST,
	OPTION_DISCOUNT,
	DEFAULT_BINDING_DURATION,
	DEFAULT_OFFER_PURPOSE
} = globalConfig;
